import {isPlatform} from "@ionic/react";

export function isBrowser() {
    return (isPlatform('mobileweb') || isPlatform("desktop")) && !(isPlatform("capacitor"));
}
